export default {

	methods: {

		async onSubmitLogin(form) {
			const { data } = await this.$api.post('/login', form);

			if (data.user) {
				// Success
				this.$store.dispatch('login', data);
				await this.$store.dispatch('syncAccountData');
				this.$root.$emit('reset-colors');
			}
		},

		async onSubmitSignup(form) {
			const { data } = await this.$api.post('/signup', form);

			// Success
			this.$store.dispatch('login', data);
		},

	},

};
